import { EProgramVersionStatus } from "@/models/program/version";
import { ESubscriptionStatus } from "@/models/subscriptions/status";

export function normalizedSubscriptionStatus(status_id: ESubscriptionStatus) {
  switch (status_id) {
    case ESubscriptionStatus.NOT_STARTED:
      return "Не начат";
    case ESubscriptionStatus.IN_PROGRESS:
      return "В процессе выполнения";
    case ESubscriptionStatus.DONE:
      return "Выполнен корректно";
    case ESubscriptionStatus.FAILED:
      return "Выполнен некорректно";
    case ESubscriptionStatus.AWAITING_CONFIRMATION:
      return "Ожидает подтверждения";
    case ESubscriptionStatus.AWAITING_REPEAT_PASS:
      return "Ожидает перепрохождения";
    case ESubscriptionStatus.AWAITING_CONTINUE:
      return "Ожидает продолжения обучения";
    case ESubscriptionStatus.AWAITING_COMPLETION:
      return "Ожидает завершения программы";
    default:
      return "В архиве";
  }
}

export function normalizedSubscriptionInspectorStatus(status: number) {
  switch (status) {
    case 1:
      return "Ожидание";
    case 2:
      return "Отклонено";
    case 3:
      return "Подтверждено";
    default:
      return "";
  }
}

export function normalizedSubscriptionLevel(status: number) {
  switch (status) {
    case 1:
      return "Новичок - не использует знания на практике";
    case 2:
      return "Специалист - применяет знания на практике под контролем";
    case 3:
      return "Профессионал - работает самостоятельно";
    case 4:
      return "Гуру - профессионал, способный обучать других";
    default:
      return "";
  }
}

export function normalizedProgramVersionStatus(status: EProgramVersionStatus) {
  switch (status) {
    case EProgramVersionStatus.APPROVED:
      return "Согласовано";
    case EProgramVersionStatus.NOT_APPROVED:
      return "Отклонено";
    case EProgramVersionStatus.SEND_FOR_APPROVAL:
      return "На согласовании";
    default:
      return "Создана";
  }
}
